import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Fees"],
});


const paymentSummaryApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentSummary: builder.query({
      query: ({ term_id, session_id } = {}) => {
        const params = new URLSearchParams();
        if (term_id) params.set("term_id", term_id);
        if (session_id) params.set("session_id", session_id);
        const qs = params.toString();
        return `/fees/summary${qs ? `?${qs}` : ""}`;
      },
      providesTags: ["Fees"],
    }),
  }),
});

export const {
  useGetPaymentSummaryQuery,
  
} = paymentSummaryApiSlice;
